function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8848 3H1.08727C0.473939 3 0 2.33766 0 1.51948C0 0.662338 0.473939 0 1.08727 0H21.9127C22.4982 0 23 0.662338 23 1.51948C22.9721 2.33766 22.4982 3 21.8848 3Z",
  fill: "#0251BC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.912 8H1.0608C0.4896 8 0 7.34615 0 6.5C0 5.69231 0.4624 5 1.0608 5H15.9392C16.5104 5 17 5.65385 17 6.5C16.9728 7.34615 16.5104 8 15.912 8Z",
  fill: "#0251BC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8706 13H1.10118C0.508235 13 0 12.3462 0 11.5C0 10.6923 0.48 10 1.10118 10H10.8988C11.4918 10 12 10.6538 12 11.5C11.9718 12.3077 11.4918 13 10.8706 13Z",
  fill: "#B6E4FF"
});

var SvgFilterIcon = function SvgFilterIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 13,
    viewBox: "0 0 23 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilterIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter__icon.aad1c014.svg";
export { ForwardRef as ReactComponent };